<template>
  <div class="project-addDevice-dialog">
    <custom-dialog width="1000px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <!-- 表格 -->
        <div class="product-wrap">
          <div class="search-hd">
            <el-form :inline="true" @submit.native.prevent>
              <!-- v-if="model.isOwner && funcView.project_transfer_device" -->
              <el-form-item >
                <el-button type="primary" icon="icon icon-yidong" :disabled="!tableSelect.length" @click="onTransfer()">{{$t('dms_project_selectDevice_dialog.zhuan_yi_she_bei') }}</el-button>
              </el-form-item>
              <!-- v-if="model.isOwner && funcView.project_bind_device" -->
              <el-form-item >
                <el-button type="primary" icon="el-icon-plus" @click="onBind()" v-if="model.siteId">{{ $t('dms_project_selectDevice_dialog.bang_ding_she_bei') }}</el-button>
              </el-form-item>
              <!-- 搜索栏 -->
              <el-form-item style="float: right; margin-right: 0">
                <search-input v-model="formSearch.search" :placeholder="$t('dms_project_selectDevice_dialog.ji_shen_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
              </el-form-item>
              <el-form-item style="float: right" v-if="!model.siteId">
                <custom-select
                  url="locationSiteList"
                  v-model="formSearch.siteId"
                  :listener="`${formSearch.locationId}`"
                  :props="{ label: 'siteName', value: 'siteId' }"
                  :params="{ locationId: formSearch.locationId }"
                  width="100%"
                  @change="onPageChange({ page: 1 })"
                  :placeholder="$t('dms_project_selectDevice_dialog.qu_yu')"
                ></custom-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="table-bd">
            <custom-table
              ref="table"
              type="checkbox"
              v-model="tableSelect"
              :data="deviceList"
              :loading="isLoading"
              tableCode="project_device"
              :filterArr="model.siteId ? ['floorName', 'siteName'] : []"
              @filter="filterChange"
              @sort="sortChange"
              height="500px"
            ></custom-table>
          </div>
          <div class="table-page">
            <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <!-- <el-button type="primary" @click="saveChoose">{{ $t('com_confirm') }}</el-button> -->
      </div>
      <project-bindDevice-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onChangeDevice"></project-bindDevice-dialog>
      <project-transferDevice-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="onChangeDevice"></project-transferDevice-dialog>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import projectBindDeviceDialog from './project_bindDevice_dialog.vue';
import projectTransferDeviceDialog from './location_transferDevice_dialog.vue';

export default {
  components: { projectBindDeviceDialog, projectTransferDeviceDialog },
  mixins: [dialogMixins],
  data() {
    return {
      isLoading: false,
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        search: '',
        locationId: '',
        floorId: '',
        siteId: '',
      },
      totalRows: null,
      deviceList: [],
      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
    };
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.initDialog();
    this.getTableList();
    this.getFuncView();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
        this.formSearch.locationId = this.model.locationId;
        this.formSearch.siteId = this.model.siteId;
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    onChangeDevice: function () {
      // 延迟一下 关键会慢一点
      setTimeout(() => {
        this.getTableList();
        this.$emit('success');
      }, 1000);


    },
    // 获取关联列表
    getTableList: function () {
      this.isLoading = true;

      this.$getJSON(apis.locationDevicePage, this.formSearch).then((res) => {
        this.isLoading = false;
        this.deviceList = res.data ? res.data.list : [];
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    onBind: function () {
      const siteName = this.model.data.siteName ? `/${this.model.data.siteName}` : '';
      const title = this.$t('dms_project_selectDevice_dialog.oooshe_bei', [this.$t('dms_project_selectDevice_dialog.bang_ding'),this.model.locationName,siteName]);
      this.dialogModel.title = title;
      this.dialogModel.data = this.model.data;
      this.dialogVisible = true;
    },
    onTransfer: function () {
      const siteName = this.model.data.siteName ? `/${this.model.data.siteName}` : '';
      const title = this.$t('dms_project_selectDevice_dialog.oooshe_bei', [this.$t('dms_project_selectDevice_dialog.zhuan_yi'),this.model.locationName,siteName]);
      this.dialogModel1.title = title;
      this.dialogModel1.data = this.model.data;
      this.dialogModel1.tableSelect = this.tableSelect;
      this.dialogVisible1 = true;
    },
  },
};
</script>

<style lang="scss">
.project-addDevice-dialog {
  .search-container {
    padding: 0px 8px 8px;
    margin-bottom: 16px;
    background: #f6f6fa;
    border-radius: 2px;
    overflow: hidden;
    // overflow: hidden;
    .el-form-item {
      // width: 14.2%;
      width: 16.6%;
      margin: 0 !important;
      margin-bottom: 0px !important;
      padding: 0 8px;
      .el-input__inner {
        border: none !important;
      }
    }
    > .advanced-footer {
      overflow: hidden;
      margin-top: 10px;
      .button-group {
        margin-right: 8px;
        margin-bottom: 8px;
        margin-top: 8px;
        float: right;
      }
    }
    .el-input-group__prepend {
      background-color: #ffffff;
      border: none;
      .el-select {
        vertical-align: baseline !important;
      }
    }

    .el-input.is-disabled .el-input__inner {
      background-color: #fcfcfc;
    }

    .el-form-item--small .el-form-item__label {
      margin-top: 16px;
      font-size: 12px;
      padding: 0px 0px 4px 0 !important;
      color: #495057;
      line-height: 24px;
    }
  }
}
</style>
